import PropTypes from 'prop-types'
import DatePicker from 'react-datepicker'
import { useTranslation } from 'react-i18next'

import SearchField from '../../../../../components/FormLegacy/FormFieldsV2/SearchField'
import { getChecklistStatusFilterOptions } from '../../helpers'

const ChecklistsNavbar = ({
  search,
  selectedTab,
  dateFilter,
  setSiteLoading = () => {},
  setSearch = () => {},
  setDateFilter = () => {},
  setSelectedTab = () => {},
}) => {
  const { t } = useTranslation(['checklists-dashboard'])
  const checklistStatusFilterOptions = getChecklistStatusFilterOptions(t)
  return (
    <div className="ctp-checklists-wrapper-navbar">
      <div className="single-row">
        <div className="left-side">
          {checklistStatusFilterOptions.map((tabFilter) => (
            <div
              className={`message-type-filter ${
                selectedTab && tabFilter.id === selectedTab.id ? 'active' : ''
              }`}
              key={tabFilter.id}
              onClick={() => setSelectedTab(tabFilter)}
            >
              {tabFilter.text}
            </div>
          ))}
        </div>
        <div className="right-side">
          <DatePicker
            className={'input borderless'}
            placeholderText={t('checklists-dashboard:navbar.moveInDatePlaceholder')}
            isClearable={true}
            selected={dateFilter || null}
            onChange={setDateFilter}
            maxDate={new Date()}
          />
          <SearchField
            placeholder={t('checklists-dashboard:navbar.searchPlaceholder')}
            value={search}
            onChange={(e) => {
              setSiteLoading(true)
              setSearch(e.target.value)
            }}
          />
        </div>
      </div>
    </div>
  )
}

ChecklistsNavbar.propTypes = {
  search: PropTypes.string,
  statusFilters: PropTypes.array,
  setSiteLoading: PropTypes.func,
  setSearch: PropTypes.func,
  setDateFilter: PropTypes.func,
  setSelectedTab: PropTypes.func,
  selectedTab: PropTypes.object,
  dateFilter: PropTypes.instanceOf(Date),
}

export default ChecklistsNavbar
